import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/_services/auth.service';
import { LoaderService } from 'app/_services/loader.service';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { process, State } from '@progress/kendo-data-query';
import moment = require('moment');
import { FormControl, FormGroup } from '@angular/forms';
import { utils, WorkBook, write } from 'xlsx';
import { environment } from '.../../environments/environment';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Color } from '@progress/kendo-drawing';
import { LegendComponentGenerated } from '@progress/kendo-angular-charts';


declare var $: any;
declare var google: any;
declare var firebase: any;
declare var MapLabel: any;
var stopAnimation = true;

declare const MarkerClusterer;

@Component({
  selector: 'deviceDetailsMgt',
  templateUrl: './deviceDetails.component.html',
  styleUrls: ['./deviceDetails.component.css']
})
export class deviceDetailsMgt implements OnInit{
    authtoken: any;
    allUsers: any;
    prjID: string;
    showLoader: boolean;
    isSuperAdmin: boolean;
    gridDataUserList: any;
    selectedDate: any;
 

  defaultStartDate: any;
  defaultEndDate: any;
  dataRangeModal:any;
  startDate: any;
  endDate: any;
    userID: string;
    currentDateModal: Date;
  data: any;
  totalPages: any;
  len: any;
  totalitems: any;
 public  pageNo = 1;
 public limit = 50;

 public  lastPage :any;

 list = [];
  filterdata: any;
 


    constructor(
        private loaderService: LoaderService,
        private auth: AuthService,
        private http: HttpClient,
        public afs: AngularFirestore,
      ) { 
        this.authtoken = JSON.parse(localStorage.getItem('authData'));
        this.prjID = this.auth.getAuthentication().projectId;


        this.userID =  this.auth.getAuthentication().id  ;


        console.log('113',this.userID);
        



        var date = new Date();   
        this.currentDateModal=date;
        this.loaderService.status.subscribe((val: boolean) => {
          this.showLoader = val;
        });

        var firstDay = new Date();
        var lastDay = new Date();
        this.dataRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() } };

        this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
        this.defaultEndDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();

      
      }

ngOnInit() {

        this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
        this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
        
        var authData = JSON.parse(localStorage.getItem('authData'))
    
        if(authData.id == 19 || authData.id == 445){
          this.isSuperAdmin = true
        }
        else {
          this.isSuperAdmin = false
        }


        this.getAllVehiclesDetails(this.pageNo,this.limit);

  }


      ngOnDestroy(){
        // if (this.subscription){
        //     this.subscription.unsubscribe();
        // }
      }






      getAllVehiclesDetails(pages,limit) {
      
    
        this.http.get(environment.apiUrl + 'vehicles/customVehicalsDetails?prjid=' + this.prjID + '&pageNo=' + pages + '&limit=' + limit).subscribe((data) => {
         
          this.data = data;

          console.log('133',this.data.status);

          console.log('136',this.data.totalData);


          this.filterdata = this.data.totalData
          

        
          
          this.totalPages = Math.round(this.data.status/50)
        
         // console.log('136',this.totalPages);


            for (let index = 1; index <= this.totalPages ; index++) {
                this.list.push(index)
          
             }
         
        
        
        
        //   this.data = data;
        //   this.len = this.data;
          

        //   this.totalPages = Math.round(this.data.length/25) ;
        //   //this.totalPages = parseInt((this.data.length / this.limit).toFixed(0),10)
       
       
        //   this.totalitems =  this.data.length
     


         console.log('143',this.totalPages);
          
        this.lastPage = this.totalPages - 1


        // for (let index = 1; index <= this.totalPages ; index++) {
        //   this.list.push(index)
          
        // }

       
        

        

            



        

          
          
        });


          




      }

    


      first(item,evt){
      
        this.list = [];
        this.lastPage = '';
        console.log('177',item);
        this.getAllVehiclesDetails(item,this.limit);
      

      }
      
      last(item,evt){
       
        this.list = [];
        this.lastPage = '';
        console.log('186',item);
        this.getAllVehiclesDetails(item,this.limit);
        
      }

      paginationChange(item,evt){

      
        this.list = [];
        this.lastPage = '';

        console.log('195',item);

        if(item==0){

          item = 1
        }
        
       
        this.getAllVehiclesDetails(item,this.limit);

       

      }

}


// WEBPACK FOOTER //
// ./src/app/iswmMgt/custom/deviceDetails.component.ts